import React, { Component } from 'react';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonUsualText from '../../../common-components/common-usual-text';

class Task extends Component {
    render() {
        return (
            <div className="garant-fond-task">
                <ScrollAnimation animateIn="fadeInUp" offset={100} animateOnce={true} duration={1}>
                    <div className="garant-fond-task__inner-pd">
                        <div className="garant-fond-task__inner">
                            <div className="garant-fond-task__goal">Цель:</div>
                            <CommonUsualText className="garant-fond-task__text">
                                Повышение узнаваемости Гарантийного фонда среди предпринимателей и
                                компаний в Ростовской области, формирование лояльности к продуктам
                                Фонда, позиционирование Фонда как организации региональной
                                инфраструктуры поддержки МСП.
                            </CommonUsualText>
                        </div>
                    </div>
                </ScrollAnimation>
            </div>
        );
    }
}

export default Task;
